import { Tooltip } from '@mui/material';
import { Warning as WarningIcon } from '@mui/icons-material';
import { AssetPageObjectModel } from '@/poms/assetPageObjectModel';

const getTooltipText = (hideTooltip?: boolean, name?: string) => {
  if (hideTooltip) return '';
  if (name) return `${name} is a missing dependency.`;
  return 'Missing dependency';
};

export const MissingDependencyIcon = ({ hideTooltip, name }: { hideTooltip?: boolean; name?: string }) => {
  return (
    <Tooltip
      data-testid={AssetPageObjectModel.MissingDependenciesWarningIcon}
      title={getTooltipText(hideTooltip, name)}
    >
      <WarningIcon
        className='missing-dep-icon'
        sx={{
          color: 'warning.dark',
          fontSize: '14px',
          flexShrink: 0,
        }}
      />
    </Tooltip>
  );
};
